import { Clock } from 'lucide-react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { useI18n } from '@/hooks/useI18n';

/**
 * C'e' un pagamento avviato e i fondi non sono ancora arrivati.
 *
 * Serve al versamento unico: con un piano a rate lo stesso fatto e' gia' detto dal badge
 * sulla riga della rata (InstallmentStatusBadge con isProcessing), ma senza rate non c'e'
 * nessuna riga su cui appoggiarlo e il cliente vedrebbe una schermata identica a quella di
 * chi non ha mai pagato.
 *
 * Il testo non nomina il bonifico: lo stesso stato lo produce anche l'addebito SEPA, e
 * dichiarare un metodo che il frontend non conosce sarebbe una bugia il 50% delle volte.
 *
 * Avviso, non blocco. Lo stato "avviato" si accende gia' quando il cliente arriva sul
 * bonifico in Checkout, quindi comprende anche chi ha guardato l'IBAN e ha chiuso la
 * scheda: e' il cliente l'unico che sa quale dei due casi sia il suo, e il pulsante per
 * ripagare resta accanto a questo avviso.
 */
export const PaymentProcessingNotice = () => {
    const { t } = useI18n();

    return (
        <Alert variant="warning">
            <Clock className="h-4 w-4" />
            <AlertDescription className="flex flex-col gap-0.5">
                <span className="font-medium">{t('itinerary.payment.processingTitle')}</span>
                <span className="text-sm">{t('itinerary.payment.processingDescription')}</span>
                <span className="text-sm">{t('itinerary.payment.retryHint')}</span>
            </AlertDescription>
        </Alert>
    );
};
